@layer design-system {
  .root {
    width: 100%;
    margin: 0;
    border: none;
    border-top: 2px solid var(--border-soft);
  }
}
